module.exports = require('./components/ktoquiz');
